<template>
  <div :class="['tmallBox', { inApp: $root.$data.isApp }]">
    <common-title titleName="激活中心" :bcColor="'none'" :zIndex="1000"></common-title>
    <dl class="activeType">
      <dd :class="{ memberActive: index == currentIdx }" v-for="(item, index) in activeType" :key="index"
        @click="currentIdx = index">
        {{ item.name }}
        <span></span>
      </dd>
    </dl>

    <div v-if="currentIdx === 0">
      <div class="from_content">
        <div class="step1">
          <h2>1.请选择购买课程/会员/电子书的渠道</h2>
          <div class="channel" v-for="(item, index) in storeList" :key="index" @click="selected = index">
            <div class="channel-left">
              <img :src="item.icon" /><span>{{ item.name }}</span>
            </div>
            <img :src="selected === index ? addcheck : nocheckact" />
          </div>
        </div>
        <div class="step2">
          <h2>2.请输入淘宝/抖音/微信/微博订单编号</h2>
          <van-field v-model.trim="tmallCard" type="input" placeholder="请输入订单编号" />
          <h3>可在淘宝、抖音、微信、微博订单中查找“订单编号”</h3>
        </div>
      </div>

      <div class="fixedbottom">
        <div class="tmallBtn" :class="{ active: selected !== -1 }" @click="onClickTmall">
          点击激活
        </div>
      </div>
    </div>
    <MemberActive v-if="currentIdx === 1" />
    <Loading ref="load" />
    <CourseList @success="receiveSuccess" :productList="productOptionList" ref="sku" />
    <PackageList @success="receiveSuccess" :packageList="packageOptionList" ref="package" />
    <ActiveSuccess ref="active" :isEbook="isEbook" />
    <MemberSuccess @changeShow="changeShow" :onShow="onShow" />
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
// eslint-disable-next-line import/no-cycle
import { resCourseTmallSku } from '@/api/personal/courseTmall';
import Loading from '@/components/loading/loading.vue';
import CourseList from './component/courseList.vue';
import PackageList from './component/packageList.vue';
import ActiveSuccess from './component/activeSuccess.vue';
import MemberActive from './component/memberActive.vue';
import MemberSuccess from './component/memberSuccess.vue';

export default {
  components: {
    CommonTitle,
    Loading,
    CourseList,
    PackageList,
    ActiveSuccess,
    MemberActive,
    MemberSuccess,
  },
  data() {
    return {
      // 天猫订单号
      tmallCard: '',
      productOptionList: [],
      packageOptionList: [],
      selected: -1,
      nocheckact: require('@/assets/img/personalCenter/nocheckact.png'),
      addcheck: require('@/assets/img/personalCenter/addcheck.png'),
      storeList: [
        {
          icon: require('@/assets/img/personalCenter/tmall-taobao.png'),
          name: '淘宝',
          channelType: 1,
        },
        {
          icon: require('@/assets/img/personalCenter/tmall-douyin.png'),
          name: '抖音',
          channelType: 2,
        },
        {
          icon: 'https://iqh-zt-pord-cdn.iqihang.com/wechatIcon.png',
          name: '微信',
          channelType: 3,
        },
        {
          icon: require('@/assets/img/personalCenter/weibo.png'),
          name: '微博',
          channelType: 4,
        },
      ],
      activeType: [
        { id: 0, name: '电商渠道激活' },
        { id: 1, name: '防伪码激活' },
      ],
      currentIdx: 0,
      onShow: false,
      isEbook: false,
    };
  },

  computed: {},
  mounted() { },

  methods: {
    receiveSuccess(item) {
      if (item.packageType === 2) {
        // 会员套餐
        this.isEbook = false;
        this.onShow = true;
      } else {
        this.isEbook = !!item?.isEbook;
        this.$refs.active.show = true;
      }
    },
    async onClickTmall() {
      if (this.selected === -1) {
        this.$toast('请选择购买课程/会员/电子书的渠道后再激活课程');
        return;
      }
      if (!this.tmallCard) {
        this.$toast(`请输入${this.storeList[this.selected].name}订单号`);
      } else {
        this.$refs.load.show = true;
        const res = await resCourseTmallSku(
          this.tmallCard,
          this.storeList[this.selected].channelType,
        );
        if (res.code === 0) {
          const { packageOptionList, productOptionList } = res?.data;
          Object.assign(this, { productOptionList, packageOptionList });
          if (productOptionList?.length) {
            // 产品
            this.$refs.sku.show = true;
            this.productOptionList.forEach((item, i) => {
              Object.assign(item, { setId: i });
            });
          }
          if (packageOptionList?.length) {
            this.$refs.package.show = true;
            // if (packageOptionList[0].packageType == 2) {
            //   //会员套餐
            //   this.onShow = true;
            // } else {
            //   //普通套餐
            //   this.$refs.package.show = true;
            // }
          }
        } else {
          this.$toast(res.msg);
        }
        this.$refs.load.show = false;
      }
    },
    changeShow() {
      this.onShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tmallBox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding-top: 120px;
  padding-bottom: 170px;
  background: url('../../../assets/img/personalCenter/tmall-bg.png') no-repeat;
  background-size: 100%;

  &.inApp {
    padding-top: 80px;
    padding-bottom: 0;
  }

  .activeType {
    display: flex;
    justify-content: space-between;
    width: 670px;
    height: 80px;
    margin: 0 auto 24px;
    line-height: 80px;
    background: #fff;
    border-radius: 20px;

    dd {
      position: relative;
      width: 50%;
      color: #333;
      font-weight: 400;
      font-size: 28px;
      text-align: center;

      span {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        width: 50px;
        height: 6px;
        margin: 0 auto;
        background-color: #ff6c02;
        border-radius: 10px;
        visibility: hidden;
      }
    }

    dd:first-child::after {
      position: absolute;
      top: 20px;
      right: -10px;
      display: block;
      clear: both;
      width: 2px;
      height: 40px;
      background-color: #f6f6f6;
      content: '';
    }

    .memberActive {
      span {
        visibility: visible;
      }
    }
  }

  ::v-deep .commonTitle {
    .titleName {
      color: #fff;
      font-size: 40px;
    }

    .backButton {
      width: 44px;
      height: 48px;
      background: url('../../../assets/img/personalCenter/tmall-back.png') no-repeat;
      background-size: 100%;
    }
  }

  .from_content {
    width: 670px;
    margin: 0 auto;
    padding: 64px 60px 120px 60px;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);

    .step1 {
      >h2 {
        margin-bottom: 32px;
        color: #333;
        font-weight: 500;
        font-size: 32px;
      }

      .channel {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        width: 550px;
        height: 120px;
        margin: 24px auto;
        padding: 0 32px;
        background: #f8f9fb;
        border-radius: 20px;

        .channel-left {
          display: flex;
          align-items: center;
          justify-content: space-between;

          img {
            width: 72px;
            height: 72px;
            margin-right: 24px;
          }

          span {
            color: #333;
            font-weight: 500;
            font-size: 28px;
          }
        }

        >img {
          width: 40px;
          height: 40px;
        }
      }
    }

    .step2 {
      padding-top: 32px;

      >h2 {
        margin-bottom: 32px;
        color: #333;
        font-weight: 500;
        font-size: 32px;
      }

      >h3 {
        padding-top: 16px;
        color: #fc7e36;
        font-weight: 400;
        font-size: 24px;
        line-height: 34px;
      }
    }

    ::v-deep .van-cell {
      padding: 0;

      .van-field__body {
        .van-field__control {
          width: 275px;
          height: 60px;
          padding-left: 16px;
          color: #333;
          font-weight: 400;
          font-size: 14px;
          background: #f8f9fb;
          border-radius: 10px;
        }

        input::-webkit-input-placeholder {
          color: #a5a5a5;
        }
      }
    }
  }

   .fixedbottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    padding-top: 32px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    .tmallBtn {
      width: 678px;
      height: 80px;
      margin: 0 auto;
      color: #fff;
      font-size: 32px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
      opacity: 0.5;
    }
  }

  .tmallBtn.active {
    opacity: 1;
  }
}
</style>
